import React, { useEffect } from 'react';
import TestWidgetsView from './TestWidgetsView';
import { useTheme } from '../../../stores/useTheme';

const listOfWidgets = [
  { name: 'StatsConsole', url: '/StatsConsole/' },
  // { name: 'Wrong url', url: '/abcd' },

]

export default function TestWidgetsExamplesList() {
  const [widget, setWidget] = React.useState(listOfWidgets[0]);
  
  const { theme, toggleTheme } = useTheme();
  


  const ListButton = ({ widget }: { widget: any }) => {
    return (
      <button 
        className='w-full h-[30px] p-2 rounded-[5px] bg-[#333333] text-[#999999] text-[12px] leading-[16px] font-medium mb-1 cursor-pointer 
          hover:bg-[#4f8f36] hover:text-[#ffffff] active:transform active:translate-y-0.5 focus:outline-hidden' 
        onClick={() => setWidget(widget)}>
          {widget.name}
      </button>
    );
  };

  return (
    <div className='flex flex-col sm:flex-row h-full bg-base120 overflow-x-hidden'>
      <div className='w-full sm:w-[300px] border border-base110 flex flex-col'>
        {listOfWidgets.map((item) => <ListButton key={item.name} widget={item} />)}
      </div>
      <div className='w-full h-[30px] flex-col text-[#CCCCCC] flex items-center'>
        <div className='sm:text-[24px] mt-4'>Link Generator for - {listOfWidgets[0].name}</div>
        <TestWidgetsView widgetUrl={widget.url} />
      </div>
    </div>
  );
}


